"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require("../../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _tokens = require("../../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

require("./FilterField.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterField = function (_PureComponent) {
  _inherits(FilterField, _PureComponent);

  function FilterField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterField.__proto__ || Object.getPrototypeOf(FilterField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _this.handleKeyDown = function (e) {
      if (e.key === "Escape") {
        _this.props.onEscape(e.target.value);
      } else if (e.key === "Enter") {
        _this.props.onEnter(e.target.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterField, [{
    key: "render",
    value: function render() {
      var ariaLabel = this.props.placeholderText || "Filter List"; // TODO: i18n
      var cn = this.props.hasError ? "filter-wrapper__input--has-error" : "";
      return _react2.default.createElement(
        "div",
        { className: "aclui-multiselect__filter-wrapper" },
        _react2.default.createElement(_Icon2.default, { type: "search", color: _tokens2.default.color.blackLighten50 }),
        _react2.default.createElement("input", {
          "aria-label": ariaLabel,
          className: cn,
          disabled: this.props.isDisabled,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyDown,
          placeholder: this.props.placeholderText,
          ref: this.props.inputRef,
          type: "text",
          value: this.props.value
        })
      );
    }
  }]);

  return FilterField;
}(_react.PureComponent);

FilterField.propTypes = {
  hasError: _propTypes2.default.bool,
  inputRef: _propTypes2.default.func,
  isDisabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  placeholderText: _propTypes2.default.string,
  value: _propTypes2.default.string
};

FilterField.defaultProps = {
  hasError: false,
  inputRef: function inputRef() {},
  isDisabled: false,
  onEnter: function onEnter() {},
  onEscape: function onEscape() {},
  placeholderText: "",
  value: ""
};

exports.default = FilterField;